import React, { useState } from "react";


const Login = () => {
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const handleInputChange = (field, value) => {
    setLoginData({ ...loginData, [field]: value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log("Login Data:", loginData);
    // Add login logic here (e.g., API call)
  };

  return (
    <div className="edit-about login-container">
        <div className="login-ol">

      <h2>Login</h2>
      <form onSubmit={handleFormSubmit} className="login-form">
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={loginData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={loginData.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            required
          />
        </div>
        <div className="button-group">
          <button type="submit" className="save-btn">
            Login
          </button>
        </div>
      </form>
        </div>
    </div>
  );
};

export default Login;
